import wire from '../wire';
import template from './channels.html';
import registerComponents from './components';
import ChannelsController from './controller';

var module = wire('channels', template, ChannelsController, 'ChannelsController', '/channels?id');

registerComponents(module);

export default module;



// WEBPACK FOOTER //
// ./app/pages/channels/_index.js